var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLetter2 = function SvgLetter2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Letter2_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 18 .06-14.295h8.044V2h1.852c.584 0 1.078.192 1.45.575.352.353.564.878.584 1.422v11.905c0 .524-.181 1.029-.514 1.422-.372.434-.906.666-1.52.666H4V18Zm1.087-1.05h8.88c.301 0 .543-.1.724-.282.181-.191.282-.464.262-.766 0-.474-.262-1.02-1.007-1.02h-1.339a.506.506 0 0 1-.513-.524v-3.965H7.362a.506.506 0 0 1-.513-.524c0-.303.221-.525.513-.525h4.732V7.61H7.362a.506.506 0 0 1-.513-.525c0-.302.221-.524.513-.524h4.732V4.734H5.087V16.95Zm8.024-3.096h.835c.312 0 .614.06.906.191l.101.04V4.089c0-.312-.09-.585-.272-.766-.191-.192-.423-.283-.735-.283h-.835v10.815Z",
    fill: "#A96823"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Letter2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(4 2)",
    d: "M0 0h12v16H0z"
  })))));
};
export default SvgLetter2;